// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HVij","importantInfo":"styles_importantInfo__2GGFW"};